import { render, staticRenderFns } from "./DappDetailedOrbitContentFilter.vue?vue&type=template&id=e06c4590&scoped=true"
import script from "./DappDetailedOrbitContentFilter.vue?vue&type=script&lang=ts"
export * from "./DappDetailedOrbitContentFilter.vue?vue&type=script&lang=ts"
import style0 from "./DappDetailedOrbitContentFilter.vue?vue&type=style&index=0&id=e06c4590&prod&lang=scss&scoped=true"
import style1 from "./DappDetailedOrbitContentFilter.vue?vue&type=style&index=1&id=e06c4590&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06c4590",
  null
  
)

export default component.exports